import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import { Box, Button } from 'shared/ui'
import { type DeleteTeamModalStore } from 'entities/Teams/ui/DeleteTeamModal/store/deleteTeamModalStore'

type IDeleteTeamModalActionsProps = {
  store: DeleteTeamModalStore
  id: number
}

export const DeleteTeamModalActions: FC<IDeleteTeamModalActionsProps> = observer(
  ({ store, id }) => {
    const { deleting, closeDeleteModal, handleDeleteTeam } = store

    return (
      <Box display='flex' gap={1} flexDirection='column'>
        <Button
          fullWidth
          text='Yes, delete'
          disabled={deleting}
          loading={deleting}
          typeBtn='contained'
          onClick={() => handleDeleteTeam(id)}
        />
        <Button
          fullWidth
          text='Cancel'
          typeBtn='contained'
          contained='secondary'
          disabled={deleting}
          onClick={closeDeleteModal}
        />
      </Box>
    )
  }
)
